import { defa }          from 'defa-object';
import EndpointModel     from 'scripts/poppet/endpoint-model';
import Zone              from 'scripts/defa/zones/model-zone';

/**
 * defa.models.PickupTime
 * The DEFA PickupTime model.
 * @version 1.2.0
 */


const ZoneHolder = EndpointModel.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({}, EndpointModel.prototype.defaults,
	{
		zones: [],
		zoneIds : [],

		// maxCount The maximum number of zones
		maxCount: 6
	}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	isZoneInUse: function( zoneNumber ) {
		//TODO: Check if the zone is being used and should be displayed
		return true;
	},

	getZone: function( zoneNumber ){
		return this.get('zones')[zoneNumber];
	},


	_getModels: function() {
		if(!this.get('zones').length) {
			//Array is empty. create Models
			let zoneArray = []
			for(let i = 1; i <= this.get('maxCount'); i++) {
				let zone = new Zone();
				zone.set({zoneNumber: i});
				zone.set({unitId: this.get('id')});
				zone.set({id: this.get('zoneIds')[i]});
				zoneArray[i] = zone;
			}

			this.set({zones: zoneArray}) 
		}

		
		//Return zone models
		return this.get('zones')
	},
	
} );

export default ZoneHolder;